/* ws-shop-motion.js — お店の「ふわっと」動き（試作 2026-10-04）
   スクロールで見えてきた見出し・商品カード・記事カードを、下から順に浮かばせる。
   守ること:
   - 画面に最初から見えている部分は一切動かさない（表示の速さ・検索評価を落とさない）
   - 商品ページの価格・カートの部分（main-product）、ヘッダー、フッターは動かさない
   - 「動きを減らす」設定の端末では何もしない
   - 失敗しても今の見た目のまま（全部 try で包む・3秒の保険で必ず表示） */
(function () {
  'use strict';
  try {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    // 買う部分（カートに入れるフォームがある区画）は丸ごと動かさない
    function isBuyArea(sec) { return /main-product|featured-product/.test(sec.id || '') || !!sec.querySelector('form[action*="/cart/add"], product-info'); }
    var PICK = [
      '.title-wrapper-with-link', '.title-wrapper', '.section-header', '.rich-text__blocks',
      '.grid__item', '.multicolumn-list__item', '.banner__box', '.image-with-text__content',
      '.article-template__content h2', '.article-template__content h3',
      '.article-template__content img', '.article-card-wrapper'
    ].join(',');
    var fold = window.innerHeight * 0.92, vw = document.documentElement.clientWidth;
    var marked = [];
    var sections = main.querySelectorAll('.shopify-section');
    for (var s = 0; s < sections.length; s++) {
      var sec = sections[s];
      if (isBuyArea(sec)) continue;
      var els = sec.querySelectorAll(PICK);
      var count = new Map();
      for (var e = 0; e < els.length; e++) {
        var el = els[e];
        if (el.closest('.wsm-r')) continue;                 // 入れ子は外側だけ
        var rc = el.getBoundingClientRect();
        if (rc.top < fold) continue;                          // 最初から見えている物は触らない
        if (rc.left < -2 || rc.right > vw + 2) continue;      // 横スライドで画面の外にある物は触らない（見張りが届かない）
        var p = el.parentNode, i = count.get(p) || 0;
        count.set(p, i + 1);
        el.style.setProperty('--i', Math.min(i, 6));
        el.classList.add('wsm-r');
        marked.push(el);
      }
    }
    if (!marked.length) return;
    document.documentElement.classList.add('wsm-shop');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('wsm-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    marked.forEach(function (el) { io.observe(el); });
    // 保険: 印刷・ページ内ジャンプ等で見張りが動かなくても、表示されないままにはしない
    window.addEventListener('beforeprint', function () { marked.forEach(function (el) { el.classList.add('wsm-in'); }); });
    if (location.hash) setTimeout(function () { marked.forEach(function (el) { el.classList.add('wsm-in'); }); }, 3000);
  } catch (err) {
    try { document.documentElement.classList.remove('wsm-shop'); } catch (e2) {}
  }
})();
